import React from 'react';
import Dropdown from 'react-bootstrap/esm/Dropdown';
import { SelectStyled } from './style';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UseCampanhaHook } from 'hooks/campanha-hook';
import { UseCampanhaContext } from 'context/campanha-context';

interface filterItems {
    id: string;
    label: string;
}

const CustomSelect = ({ ...props }) => {

    const filteredItems: filterItems[] = props.options;

    const { appliedFilters } = UseCampanhaContext();
    const { applyFilter } = UseCampanhaHook();

    const selectedId = appliedFilters?.[props.value];

    const selected = selectedId
        ? props.options.find(item => item.id === selectedId)
        : undefined;

    const isSelected = (id: string) => { // chama selected
        return selected?.id?.indexOf(id) >= 0;
    };

    const onItemClicked = item => { // considerando primeiro clique no filtro
        isSelected(item.id) //chama isSelected
            ? applyFilter({ [props.value]: '' }) //falso, coloca id e valor no appliedFilters
            : applyFilter({ [props.value]: item.id });
    };

    return (
        <Dropdown drop="down" as={SelectStyled}>
            <Dropdown.Toggle>
                {selected?.label || props.defaultOption}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {filteredItems?.map(item => (
                    <>
                        <Dropdown.Item
                            value={item.id}
                            key={item.id}
                            as="button"
                            type="button"
                            active={item.id === selected?.id}
                            onClick={() => onItemClicked(item)}
                        >
                            {item.label}
                            {isSelected(item.id) && (
                                <FontAwesomeIcon icon={faTimes} size="lg" />
                            )}
                        </Dropdown.Item>
                    </>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
};

export default CustomSelect;